import { useContext } from 'react'

import { BasketAPIContext } from './BasketContext'

export const useBasketApi = () => {
  const basketApi = useContext(BasketAPIContext)

  if (!basketApi) {
    throw Error('Basket API not found')
  }

  return basketApi
}
